import type { Theme } from '@mui/material/styles/createTheme'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import MuiToggleButton from '@mui/material/ToggleButton'
import type { ToggleButtonProps } from './ToggleButton.types'
import { sizeStyles as buttonSizeStyles } from '../Button/Button.styles'

type CssProps = ToggleButtonProps & { theme?: Theme }

const commonStyles = () => css`
  color: rgba(0, 0, 0, 87%);
  padding: 0 12px;
  letter-spacing: normal;
  line-height: normal;
  white-space: nowrap;
`

const toggleButtonSizeStyles = ({ size }: Pick<CssProps, 'size'>) => {
  switch (size) {
    case 'xSmall':
    case 'small':
      return css`
        min-width: 48px;
      `
    default:
      return css`
        min-width: 75px;
      `
  }
}

const outlinedStyles = ({ theme }: Pick<CssProps, 'theme'>) => css`
  position: relative;
  background-color: ${theme?.palette.common.white};
  border: 1px solid ${theme?.palette.divider};
  ::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
    color: inherit;
    background-color: currentcolor;
    opacity: 0;
  }
  &:hover {
    background-color: ${theme?.palette.common.white};
    border: 1px solid ${theme?.palette.divider};
    ::before {
      opacity: 0.08;
    }
  }
`

const selectedStyles = ({
  theme,
  color = 'secondary',
}: Pick<CssProps, 'theme' | 'selected' | 'color'>) => css`
  opacity: 0.8;
  &.Mui-selected {
    opacity: 1;
    background-color: ${theme?.palette[color].main};
    color: ${theme?.palette[color].contrastText};
    &:hover {
      background-color: ${theme?.palette[color].main};
    }
  }
`

export const ToggleButton = styled(MuiToggleButton)<Partial<ToggleButtonProps>>`
  ${buttonSizeStyles};
  ${toggleButtonSizeStyles};
  ${outlinedStyles};
  ${selectedStyles};
  ${commonStyles};
`
